<template>
  <v-main>
    <router-view></router-view>
  </v-main>
</template>
<script>
export default {
    mounted() {
    document.querySelector('.v-application--wrap').style =
      "background: url('/background.png') !important;"
  }
}
</script>
